import React, { useEffect, useState } from "react";
import { IconPatientJourney } from "../../../assets/icons/icon-patient-journey";
import { bulkUploadStatusClass, statusClasses } from '../../../js/api/constants';
import { CloseIcon } from "../../../assets/icons/close-icon-simple";
import { ENDPOINTS } from "../../../js/api/_config";
import axios from "axios";
import { convertDateLastContracted, convertTimeToLocation } from "../../common/constant/constant";

const BulkUploadFileDetails = ({ selectedBulkUpload, toggleDetails, setToggleDetails }) => {

    const [activeTab, setActiveTab] = useState('All')
    const [dataList, setDataList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const fetchData = async (selectedId) => {


        try {
            setIsLoading(true);

            let queryParams = { "bulkuploadID": selectedId };

            if (activeTab === "All") {
                queryParams["all"] = true;
            } else {
                if (activeTab === "Successful") queryParams["isSuccessfull"] = true
                if (activeTab === "Queued") queryParams["isQueued"] = true
                if (activeTab === "Skipped") queryParams["isSkipped"] = true
            }

            await axios.get(ENDPOINTS.PATIENT.BULK_UPLOAD_LOGS_DETAILS, { params: queryParams }).then(res => {
                if (res.data.success && res.data.data.items && res.data.data.items.length > 0) {
                    setDataList(res.data.data.items);
                } else {
                    setDataList([]);
                }

            }).catch((error) => {
            })

        } finally {
            setIsLoading(false);
        }


    };

    useEffect(() => {
        if (selectedBulkUpload.bulkUploadID)
            fetchData(selectedBulkUpload.bulkUploadID);
    }, [selectedBulkUpload.bulkUploadID, activeTab])

    const formateStatus = (val) => {
        if (!val) return '';

        const parts = val.split('-');

        return parts.map((part, index) => {
            if (index === 0 || index === 2) {
                return `<span class="font-bold">${part}</span>`;
            }
            return part;
        }).join(' ');
    };

    return (
        <>
            <div className="text-center w-[380px]  bg-white h-full">
                <div className="border-b border-[#B2ACC9] w-full" style={{ borderColor: 'rgb(200, 214, 230)' }}>
                    <div className="flex justify-between items-center w-full px-5 py-6">
                        <h2 className="font-semibold text-left">{selectedBulkUpload.bulkUploadFileName}</h2>
                        <button onClick={() => { setToggleDetails(false) }}><CloseIcon /> </button>
                    </div>
                </div>

                <div className="flex flex-col h-[calc(100vh-150px)]">
                    <div className="p-5 pb-0 ">
                        <div className="flex cursor-pointer mb-[30px]">
                            <div
                                style={{ color: activeTab === 'All' ? '#245CEA' : '#1A1A1B' }}
                                className="text-[15px] text-center font-medium font-mont"
                                onClick={() => setActiveTab('All')}
                            >
                                All
                                {activeTab === 'All' ? <div className="border-b border-4 h-1 relative top-2 z-10 rounded-sm" style={{ borderColor: "#245CEA" }}></div> : <div className=" h-1 border-b border-4 relative top-2 z-10 rounded-sm" style={{ borderColor: "#C8D6E6" }}></div>}
                            </div>

                            <div
                                style={{ color: activeTab === 'All' ? '#245CEA' : 'black' }}
                                className="text-[15px] text-center font-medium"

                            >
                                &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;
                                <div className=" h-1 border-b border-4 relative top-2 z-10 " style={{ borderColor: "#C8D6E6" }}></div>
                            </div>
                            <div
                                style={{ color: activeTab === 'Successful' ? '#245CEA' : '#1A1A1B', }}
                                className="text-[15px] text-center font-medium  font-mont"
                                onClick={() => setActiveTab('Successful')}
                            >
                                Successful
                                {activeTab === 'Successful' ? <div className="border-b border-4 h-1 relative top-2 z-10 rounded-sm" style={{ borderColor: "#245CEA" }}></div> : <div className=" h-1 border-b border-4 relative top-2 z-10 rounded-sm" style={{ borderColor: "#C8D6E6" }}></div>}
                            </div>

                            <div
                                style={{ color: activeTab === 'Queued' ? '#245CEA' : 'black' }}
                                className="text-[15px] text-center font-medium"

                            >
                                &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;
                                <div className=" h-1 border-b border-4 relative top-2 z-10 " style={{ borderColor: "#C8D6E6" }}></div>
                            </div>
                            <div
                                style={{ color: activeTab === 'Queued' ? '#245CEA' : '#1A1A1B', }}
                                className="text-[15px] text-center font-medium  font-mont"
                                onClick={() => setActiveTab('Queued')}
                            >
                                Queued
                                {activeTab === 'Queued' ? <div className="border-b border-4 h-1 relative top-2 z-10 rounded-sm" style={{ borderColor: "#245CEA" }}></div> : <div className=" h-1 border-b border-4 relative top-2 z-10 rounded-sm" style={{ borderColor: "#C8D6E6" }}></div>}
                            </div>

                            <div
                                style={{ color: activeTab === 'Skipped' ? '#245CEA' : 'black' }}
                                className="text-[15px] text-center font-medium"

                            >
                                &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;
                                <div className=" h-1 border-b border-4 relative top-2 z-10 " style={{ borderColor: "#C8D6E6" }}></div>
                            </div>

                            <div
                                style={{ color: activeTab === 'Skipped' ? '#245CEA' : '#1A1A1B', }}
                                className="text-[15px] text-center font-medium  font-mont"
                                onClick={() => setActiveTab('Skipped')}
                            >
                                Skipped
                                {activeTab === 'Skipped' ? <div className="border-b border-4 h-1 relative top-2 z-10 rounded-sm" style={{ borderColor: "#245CEA" }}></div> : <div className=" h-1 border-b border-4 relative top-2 z-10 rounded-sm" style={{ borderColor: "#C8D6E6" }}></div>}
                            </div>

                        </div>
                        {/* {
                            activeTab === 'All' ? (
                                <div></div>
                            ) : activeTab === 'Successful' ? (
                                <div></div>
                            ) : activeTab === 'Queued' ? (
                                <div className=""></div>
                            ) : activeTab === 'Skipped' ? (
                                <div className=""></div>
                            ) : (<></>)
                        } */}

                        <div className="text-left overflow-y-auto h-[calc(100vh-230px)]">

                            {isLoading ? (<div class="mt-[100px] spinnerwrapper !h-auto"><div class="spinner"></div></div>) : (
                                <>
                                    {dataList.length === 0 && "There are no records to display"}
                                    {dataList && dataList.length > 0 && dataList.map((data, index) => (
                                        // {dataList && dataList.length > 0 && dataList.map((_, index) => (
                                        <div key={index} className="flex items-start mb-4">
                                            <p>
                                                <span className="recruiter-intials">
                                                    {data.firstName?.charAt(0).toUpperCase()}
                                                    {data.lastName?.charAt(0).toUpperCase()}
                                                </span>
                                            </p>
                                            <div className="pl-1">
                                                <span className="block font-mont text-[14px] break-words" dangerouslySetInnerHTML={{ __html: data.patientName }}></span>
                                                <p className="mt-2 text-[#667783] text-xs">{convertDateLastContracted(convertTimeToLocation(data.createdAt))}</p>
                                                <p className={`text-xs mt-2 text-gray-500 rounded-3xl px-2 py-2 status-bubble inline-block 
                                                ${data.isQueued
                                                        ? bulkUploadStatusClass.isQueued
                                                        : data.isSkipped
                                                            ? bulkUploadStatusClass.isSkipped
                                                            : data.isSuccessfull
                                                                ? bulkUploadStatusClass.isSuccessfull
                                                                : ''
                                                    }
                                                `}>
                                                    {data.isQueued && "Queued"}
                                                    {data.isSkipped && "Skipped"}
                                                    {data.isSuccessfull && "Successful"}
                                                </p>
                                            </div>
                                        </div>
                                    ))}
                                </>
                            )}
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default BulkUploadFileDetails;